import { Component, ViewChild,Input,Output, EventEmitter, effect, inject, ViewChildren, QueryList, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserService } from '@services/core/user.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { ContextMenuComponent } from 'app/components/contex-menu/context-menu.component';
import { FilterModel } from './filter.model';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-setting-field-account',
  templateUrl: 'setting-field-account.component.html',
  styleUrl: 'setting-field-account.component.css',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ContextMenuComponent, CommonModule
  ],
  providers: [NgbModal],
})
export class SettingFieldAccountComponent {
  @Input() accountFilter!: string;
  @Input() year!: number;
  @Input() version!: number;
  @Input() fundCode!: number;
  @Output() activeChange = new EventEmitter<boolean>();
  @ViewChildren('input') inputs!: QueryList<ElementRef>;
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('nameInput') nameInput: ElementRef;
  @ViewChild('ngSelect', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild(ContextMenuComponent) contextMenu!: ContextMenuComponent;
  private modalRef: NgbModalRef;
  public filter: FilterModel = new FilterModel();
  public budgetGenerateService = inject(BudgetGenerateService);
  private _identityService = inject(UserService);
  private entitySelected: Entity;
  public accountPlanVersion;
  private timeout: any;
  public dataSource;
  public formAccount: FormGroup;
  public account;
  public titleModal:string;
  public subAccount;
  public subAccountTemp;
  public subAccountNgSelect;
  public allAccount;
  public departamentPlanVersionRevenue;
  public selectedOrigin;
  public departamentRevenueSelect;
 

  constructor(private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) {

    effect(() => {
      this.entitySelected = this._identityService.sharingEntity();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {
        
        this.getAccountPlanConfig();   
        this.getAasinetAccount();  
        this.getAasinetSubAccount();  
        this.getDepartamentBudgetConfigRevenue(); 
        this.formAccount.get('entityCode').patchValue(this.entitySelected?.code);
      }

    })


  }

  
  getDepartamentBudgetConfigRevenue() {
    const filter={...this.filter};
     filter.itemCode='3';
     delete filter.type_id;
 
     this.budgetGenerateService.getDepartamentBudgetConfig(filter).subscribe(res => {
       this.departamentPlanVersionRevenue = res.filter(d=>d.fundCode==this.fundCode);
       this.selectedOrigin=this.departamentPlanVersionRevenue[0].departamentCode;
       this.departamentRevenueSelect=this.mapSelectRevenue(this.departamentPlanVersionRevenue);
 
     })
   }


   
  mapSelectRevenue(data) {
    let newData = data.map((d) => {
      const name = d.displayName
      return {
        departamentCode: d.departamentCode,
        nameCode: d.departamentCode + ' - ' + name,
        departamentName: name,
        parentName: d.parentName,
        disabled: false,
        isActive: true
      }
    });
    return newData
  }


  /**crear formulario reactivo para account*/
  createFormAccount() {
    this.formAccount = this.formBuilder.group({
      id:[undefined],
      accountCode: [undefined, [Validators.minLength(3)]],
      subAccountCode: [undefined],
      displayName: ['', [Validators.required, Validators.minLength(3)]],
      subAccountName: [''],
      fundCode:['', [Validators.required]],
      hint: [''],
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      itemCode: ['', [Validators.minLength(1)]],
      year: ['', [Validators.required]],
      version: ['', [Validators.required]],
    });
  }



  setAccount(id) {
    return this.dataSource.find(acc => acc.id == id);
  }



  setFormAccount(account){
    this.titleModal='Editar Cuenta';
    this.subAccountNgSelect=[{subAccountCode:account.subAccountCode,nameCode:account.subAccountCode}]
    this.formAccount.patchValue(account);
    
    this.formAccount.get('subAccountCode')?.enable();
    this.formAccount.patchValue({
      subAccountCode:account.subAccountCode
    })
    this.formAccount.get('accountCode').disable();
    this.formAccount.get('accountCode')?.markAsPristine();
    this.formAccount.get('displayName')?.markAsPristine();
    this.formAccount.get('displayName')?.markAsUntouched();
    this.formAccount.get('subAccountCode')?.disable();
    this.open(this.modalAccount)
  }


    /**Actualiza el account con check*/
    updateAccountCheck(data, field, newValue) {
        this.budgetGenerateService.updateAccountPlanConfig({ id: data.id, [field]: newValue }).subscribe(res => {
         })
    }



  /**Elimina una cuenta*/
  deleteAccount(params) {
    Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Desea eliminar la cuenta ' + params.accountCode + ' ' + params.displayName + '?',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.budgetGenerateService.deleteAccountPlanConfig({ id: params.id }).subscribe(res => {
          this.notification('Cuenta ' + params.accountCode + ' ' + params.displayName + 'eliminada ');
          this.getAccountPlanConfig();
        })

      }
    })



  }

  ngOnInit() {
    this.filter.year = this.year;
    this.filter.version = this.version;
    this.filter.itemCode = this.accountFilter;
    this.createFormAccount();
    this.formAccount.get('year').patchValue(this.filter.year);
    this.formAccount.get('version').patchValue(this.filter.version);
    this.formAccount.get('itemCode').patchValue(this.filter.itemCode);
    this.formAccount.get('fundCode').patchValue(this.fundCode);
  }




  /**trae el plan de cuentas */
  getAccountPlanConfig() {
    this.budgetGenerateService.getAccountPlanConfig(this.filter).subscribe(res => {
      this.accountPlanVersion = res.filter(d=>d.fundCode==this.fundCode);
      this.dataSource = this.accountPlanVersion;
    })
  }

   /**trae las cuentas */
   getAasinetAccount() {
    this.budgetGenerateService.getAasinetAccount({code:this.accountFilter}).subscribe(res => {
      this.account = this.mapSelect(res);
      this.allAccount=res;
    })
  }

  loading(title: string) {
    Swal.fire({
      title: title,
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }

  syncAccounts() {
    this.loading('Sincronizando cuentas con Aasinet');
    forkJoin({
      accounts: this.budgetGenerateService.syncAssinetAccount(),
      subAccounts: this.budgetGenerateService.syncAssinetSubAccount()
    }).subscribe({
      next: () => {
        this.getAasinetAccount();
        this.getAasinetSubAccount();
        Swal.close();
        this.notification('Cuentas y subcuentas sincronizadas exitosamente');
      },
      error: (err) => {
        console.error('Error al sincronizar cuentas:', err);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error en la sincronización',
          text: 'No se pudieron sincronizar las cuentas con Aasinet.'
        });
      }
    });
  }



  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
      this.resetForm();
    }
  }

  /**abre el modal de agregar cuenta */
  openModalAccount() {
    this.titleModal='Agregar Cuenta';
    this.formAccount.reset();
    this.formAccount.get('id').patchValue(undefined);
    this.formAccount.get('accountCode').enable();    
    this.formAccount.get('entityCode').patchValue(this.entitySelected?.code);
    this.formAccount.get('year').patchValue(this.filter.year);
    this.formAccount.get('version').patchValue(this.filter.version);
    this.formAccount.get('fundCode').patchValue(this.fundCode);
    this.formAccount.get('subAccountCode').enable();
    this.open(this.modalAccount)
   
  }


  /**busca los las cuentas q no existen  */
  findAcountPlan(code): boolean {
    let r = false;
    try {
      r = !this.accountPlanVersion.some((a) => a.accountCode == code);
    }
    catch {
    }
    return r
  }


  /**busca los las cuentas q existen  */
  isExistAccount(code): boolean {
       return this.dataSource.some((a) => a.accountCode == code);
  }


  /**busca los las cuentas q existen  */
  findAccount(code): any {

    return this.allAccount.find((a) => a.code == code);
}


  



  /*mapea los datos del ng-select deshabilita los registros q ya entan registrado el diverso de empleado */
  mapSelect(data) {
    data=data.filter(d=>d.acceptEntries)
    let newData = data.map((d) => {
      const name = d.name
      const isActive = this.findAcountPlan(d.acceptEntries)
      return {
        accountCode: d.code.toString(),
        nameCode: d.code + ' - ' + name,
        name: name,
        disabled: !d.acceptEntries,
        isActive:d.acceptEntries
      }
    });
    return newData
  }

  getAasinetSubAccount(){
    this.budgetGenerateService.getAasinetSubAccount().subscribe(res => {
      this.subAccount=res;
      this.subAccountTemp=JSON.parse(JSON.stringify(res));
      this.subAccountNgSelect = [];
    })
  }


   /*mapea los datos del ng-select  de subcuenta*/
   mapSelectAassinet(data) {
    let newData = data.map((d) => {
      const name=d.name
       return {
        subAccountCode: d.code,
        nameCode: d.code + ' - ' + name,
        name: name
        
      }
    });
    return newData
  }

    /**valor al input de displayName */
    changeNgSelect(value) {
      const account=this.findAccount(this.formAccount.get('accountCode').value);
      this.formAccount.get('displayName').patchValue(account?.name??'');         
       if(account?.subAccountCode){
        this.subAccount=this.subAccountTemp.filter((d) => d.type == account.subAccountCode);
        this.formAccount.get('subAccountCode').enable();
        this.subAccountNgSelect=this.mapSelectAassinet(this.subAccount);        
        this.formAccount.get('subAccountCode').setValidators([Validators.required]);
        this.formAccount.get('subAccountCode').patchValue(undefined);
        this.formAccount.get('subAccountCode').markAsPristine();
        this.formAccount.get('subAccountCode').markAsUntouched();
        
      }
      else{
        this.formAccount.get('subAccountCode').clearValidators();
        this.formAccount.get('subAccountCode').markAsPristine();
        this.formAccount.get('subAccountCode').markAsUntouched();      
        this.formAccount.get('subAccountCode').patchValue('');
        this.subAccountNgSelect=[];
        this.formAccount.get('subAccountCode').disable();
      }
      
    }
  


  resetForm() {
    this.formAccount.patchValue({
      accountCode: undefined,
      displayName: undefined,
      hint: '',
      subAccountCode:undefined
    });
    this.formAccount.get('accountCode')?.markAsPristine();
    this.formAccount.get('displayName')?.markAsPristine();
    this.formAccount.get('hint')?.markAsPristine();
    this.formAccount.get('displayName')?.markAsUntouched();
    this.subAccountNgSelect=[];
    this.formAccount.get('subAccountCode')?.enable();
    this.formAccount.get('subAccountCode')?.markAsPristine();
    this.formAccount.get('subAccountCode')?.markAsUntouched();


  }

  changeNgSelectSubAccount(e){
      this.formAccount.get('subAccountName').patchValue(e.name??'');
  }




  /**al cerrar el ngselect le pasa el foco y el valor al input de displayName */
  submitNew() {
     if (this.formAccount.valid) {
      this.formAccount.value.itemCode=this.filter.itemCode;
      const dataSave=this.formAccount.value;
      dataSave.subAccountCode=dataSave.subAccountCode??-1;
      this.budgetGenerateService.saveAccountPlanConfig(dataSave).subscribe(res => {
        this.getAccountPlanConfig();
        this.close();
        this.resetForm();
        this.notification('Item guardado exitosamente');
      })
    }
  }


  /*Actualiza la cuenta*/
  submitUpdate() {
    if (this.formAccount.valid) {
     let data=this.formAccount.value;
     const account=this.setAccount(data.id);
     data.accountCode=account.accountCode;
     this.budgetGenerateService.updateAccountPlanConfig(data).subscribe(res => {
       account.displayName=this.formAccount.value.displayName;
       account.hint=this.formAccount.value.hint;
       account.subAccountCode=this.formAccount.value.subAccountCode;
       this.close();
       this.resetForm();
       this.notification('Cuenta actualizada exitosamente');
     })
   }
 }



  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }



}


